import { Dtos, SuretyAccountId, SuretyQuoteId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { accountQueryKey } from "../../account/account.keys";
import {
	bondRequestBondFormQueryKey,
	bondRequestLatestUnderwritingQueryKey,
	bondRequestPreviewsQueryKey,
	bondRequestsQueryKey,
} from "../bond-request.keys";
import { redirectToIssuedBond } from "../utils";

export const useAdminUpdateBondRequestStatus = (
	id: SuretyQuoteId,
	suretyAccountId: SuretyAccountId,
) => {
	const queryClient = useQueryClient();
	const { patch } = useRequest();

	const mutation = useMutation({
		meta: { redirectOnError: redirectToIssuedBond },
		mutationKey: ["updateBondRequestStatus", id],
		mutationFn: async ({
			data,
		}: {
			data: Dtos.Admin.SuretyQuote.UpdateStatus.Request;
			onSuccess?: () => void;
		}) => {
			await patch(`/v2/admin/surety/accounts/${suretyAccountId}/quotes/${id}/status`, data, "none");
		},
		onSuccess: (_, { onSuccess }) => {
			queryClient.invalidateQueries({ queryKey: accountQueryKey(suretyAccountId) });
			queryClient.invalidateQueries({ queryKey: bondRequestsQueryKey(id) });
			queryClient.invalidateQueries({ queryKey: bondRequestBondFormQueryKey(id) });
			queryClient.invalidateQueries({
				queryKey: bondRequestLatestUnderwritingQueryKey(id),
			});
			queryClient.refetchQueries({ queryKey: bondRequestPreviewsQueryKey() });

			if (onSuccess) {
				onSuccess();
			}
		},
	});

	return {
		updateBondRequestStatus: mutation.mutate,
		updateBondRequestStatusLoading: mutation.isPending,
		updateBondRequestStatusError: mutation.error,
	};
};
